import getAvailableScopeInfo from '~lib/common/utils/getAvailableScopes';

const scopeMixins = {
  methods: {
    getAvailableScopes(caseConf) {
      return getAvailableScopeInfo(caseConf);
    },
    getAvailableStates(states, scope) {
      return states
        .filter(state => state.scope === scope)
        .map(state => ({
          id: state.id,
          label: state.label,
        }));
    },
    getAvailableEnumValues(enumStates, stateId) {
      const state = enumStates.find(state => state.id === stateId);
      return state ? state.values : [];
    }
  }
};

export default scopeMixins;